import React from 'react';
import { Dialog, Box, Typography, Button, Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Phase31SummaryModal = ({ open, summaryData, players, onContinue }) => {
    const { t } = useTranslation();

    if (!summaryData || !players) return null;

    const isEmojiAvatar = (avatar) => {
        return typeof avatar === 'string' &&
            !avatar.startsWith('http') &&
            !avatar.startsWith('/');
    };

    const getActionText = (event) => {
        switch (event.action) {
            case 'cartas':
                return t('phase31_summary.player_called_cartas', { playerName: event.playerName });
            case 'baciga':
                return t('phase31_summary.player_called_baciga', { playerName: event.playerName });
            case 'bacigote':
                return t('phase31_summary.player_called_bacigote', { playerName: event.playerName });
            case 'paso':
                return t('phase31_summary.player_passed', { playerName: event.playerName });
            default:
                return event.playerName;
        }
    };

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    background: 'linear-gradient(135deg, #1a472a 0%, #2d5a3d 50%, #1a472a 100%)',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
                    overflow: 'visible',
                },
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: 'blur(8px)',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 2,
                    px: 2,
                }}
            >
                {/* Title */}
                <Typography
                    variant="h6"
                    sx={{
                        color: '#fff',
                        fontWeight: 'bold',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                        mb: 2,
                        textAlign: 'center',
                    }}
                >
                    {t('phase31_summary.title')}
                </Typography>

                {/* Events list */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        width: '100%',
                        mb: 2,
                    }}
                >
                    {summaryData.events.map((event, index) => {
                        const player = players[event.playerIndex];
                        return (
                            <Box
                                key={index}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    borderRadius: 1.5,
                                    p: 1,
                                }}
                            >
                                {/* Avatar */}
                                {isEmojiAvatar(player?.avatar) ? (
                                    <Box
                                        sx={{
                                            fontSize: '1.5rem',
                                            lineHeight: 1,
                                            width: 32,
                                            height: 32,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        {player.avatar}
                                    </Box>
                                ) : (
                                    <Avatar
                                        src={player?.avatar}
                                        sx={{ width: 32, height: 32 }}
                                    />
                                )}

                                {/* Action text */}
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: '0.9rem',
                                        flex: 1,
                                    }}
                                >
                                    {getActionText(event)}
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>

                {/* Continue button */}
                <Button
                    variant="contained"
                    onClick={onContinue}
                    sx={{
                        backgroundColor: '#ffd700',
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: '0.9rem',
                        px: 3,
                        py: 1,
                        borderRadius: 2,
                        textTransform: 'none',
                        '&:hover': {
                            backgroundColor: '#ffed4a',
                        },
                    }}
                >
                    {t('phase31_summary.continue_button')}
                </Button>
            </Box>
        </Dialog>
    );
};

export default Phase31SummaryModal;
